import { render, staticRenderFns } from "./opendata.vue?vue&type=template&id=648d38a2&"
import script from "./opendata.vue?vue&type=script&lang=js&"
export * from "./opendata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports